export const STAT_BEST_SELLERS = 'best_sellers';
export const STAT_CANCELLATION_RATE = 'cancellation_rate';
export const STAT_AVG_TIME_TO_SHIP = 'avg_time_to_ship';
export const STAT_SHIP_ON_TIME_RATE = 'ship_on_time_rate';
export const STAT_GMV = 'gmv';
export const STAT_AOV = 'aov';
export const STAT_IPT = 'ipt';

export const AVG_TIME_TO_SHIP_THRESHOLD = 48;
export const SHIP_ON_TIME_RATE_THRESHOLD = 95;
export const CANCELLATION_RATE_THRESHOLD = 4;
